import postPhoneBlockedCheck, {
    TPhoneBlockedCheck,
} from '@/src/common/queries/PostPhoneBlockedCheck'

export const checkIfPhoneNotBlocked = async (payload: TPhoneBlockedCheck) => {
    const { isBlocked } = await postPhoneBlockedCheck(payload)
    return !isBlocked
}

export const checkIfPhoneIsNotValid = async (payload: TPhoneBlockedCheck) => {
    const { isValid } = await postPhoneBlockedCheck(payload)
    return isValid
}
